import { useClient } from "@adamlip/okeoke.client";

export default function DefaultAgent({ agent }) {

    const { getName } = useClient();

    return (
        <div className="">
            <div className="">
                {getName(agent.name)}
            </div>
        </div>
    )
}